<template>
  <div class="previewGoods container1" :class="{mask:showLoading}" v-loading="showLoading" element-loading-background="#ffffff">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(v,i) in dataBreadcrumb" :key="i">
        <router-link :to="{path:v.path,query:v.query}" target="_blank">
          <span>{{v.name}}</span>
        </router-link>
      </el-breadcrumb-item>
      <span>{{goodsInfo.goodsNo}}</span>
    </el-breadcrumb>

    <div class="header">
      <div class="media">
        <div class="main_img">
          <video ref="video" v-show="showVideo" :src="videoSrc" controls="controls" controlslist="nodownload" @ended="pauseVideo(localImgIndex)">
            您的浏览器不支持 video 标签。
          </video>
          <vue-photo-zoom-pro v-show="!showVideo" :url="effectImg?effectImg:''" :out-zoomer="true" :out-zoomer-style="{zIndex:333}"></vue-photo-zoom-pro>
          <div class="play_icon" v-show="videoSrc && !showVideo" @click="playVideo">
            <i class="el-icon-video-play"></i>
          </div>
        </div>
        <div class="swiper_box">
          <Swiper ref="mySwiper" :options="swiperOption" @transitionStart="onTransitionStart">
            <swiper-slide class="swiper-slide" v-for="(v,i) in effectBanner" :key="i">
              <img :class="{active:localImgIndex==i}" v-lazy="v.filePath" alt="图片加载失败" @mouseover="pauseVideo(i)" />
            </swiper-slide>
          </Swiper>
          <div class="swiper-button-next" :class="{'swiper-button-disabled':activeIndex+4==effectBanner.length-1 || effectBanner.length<=5}" @click="nextSlide">
            <i class="myicon iconfont icon-xiayiye"></i>
          </div>
          <div class="swiper-button-prev" :class="{'swiper-button-disabled':activeIndex==0 || effectBanner.length<=5}" @click="prevSlide">
            <i class="myicon iconfont icon-xiayiye-copy"></i>
          </div>
        </div>
      </div>

      <div class="goods">
        <div class="brand">
          <div class="style" v-if="goodsInfo.styleName">{{goodsInfo.styleName}}</div>
          <div class="list" v-if="$store.getters.userTypeA">
            <router-link :to="{path:'/brandHall/brandCategory',query:{brandSerNos:goodsInfo.brandSerNo}}" target="_blank">进入品牌系列></router-link>
          </div>
        </div>
        <h3 class="name" v-if="goodsInfo.name && currentMix.mixName">
          {{goodsInfo.name+' '+currentMix.mixName}}
        </h3>
        <p class="kw">{{goodsInfo.keyWords}}</p>
        <div class="price">
          <span>多比价</span><span class="text">￥</span>
          <span class="money" v-if="currentMix.salePrice">{{currentMix.salePrice | priceValue}}</span>
          <span class="money" v-else>待定价</span>
        </div>
        <el-form class="com_el_form" ref="form" :model="goodsInfo" label-width="68px" label-position="left">
          <el-form-item class="attr_scroll" v-for="(attr,attrKey,attrIndex) in attrInfo" :key="attrIndex" :label="attr.name">
            <div class="attr_type" v-show="attr.specialType == 0">
              <el-tooltip :open-delay="500" :visible-arrow="false" effect="light" :offset="-10" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
                <button v-if="!item.isDisabled" :disabled="item.isDisabled" type="button" class="group" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">{{item.name}}</button>
              </el-tooltip>
            </div>
            <div class="attr_type" v-show="attr.specialType == 1">
              <el-popover popper-class="img_popover" trigger="hover" placement="top" :tabindex="index" v-for="(item,index) in attr.contentList" :key="index">
                <p class="hover_img"><img :src="item.filePath" alt /></p>
                <button v-if="!item.isDisabled" slot="reference" :disabled="item.isDisabled" type="button" class="color_img" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">
                  <img v-lazy="item.filePath" alt />
                </button>
              </el-popover>
            </div>
            <div class="attr_type" v-show="attr.specialType == 2">
              <el-tooltip :open-delay="500" :visible-arrow="false" effect="light" :offset="-30" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
                <button v-if="!item.isDisabled" :disabled="item.isDisabled" type="button" class="color_img" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">
                  <div class="bc_box" :style="{backgroundColor: item.colorRGB}"></div>
                </button>
              </el-tooltip>
            </div>
          </el-form-item>

          <el-form-item label="运费">
            <span>{{goodsInfo.startPlace}}</span>
            <span style="padding:0 16px">至</span>
            <City :isPreView="true" @getEndPlace="getEndPlace"></City>
            <span class="money" v-show="freightFee>=0">￥{{freightFee | priceValue}}</span>
          </el-form-item>

          <el-form-item label="服务" class="service_item">
            <div :class="{service:true,active:isShowService}" @click="changeService">
              <span>送货入户并安装</span>
              <span class="money" v-show="isShowService"> ￥{{serviceFee | priceValue}}</span>
              <i class="el-icon-check check" v-show="isShowService"></i>
            </div>
          </el-form-item>

          <el-form-item label="购买数量">
            <el-input-number v-model="goodsCount" controls-position="right" :min="1" :max="999" :precision="0" size="small" @change="onChangeCount"></el-input-number>
          </el-form-item>

          <el-form-item label="交货期" v-if="goodsInfo.sendGoodsDay">
            <div>{{goodsInfo.sendGoodsDay}}{{goodsInfo.sendGoodsDayMax?'—'+goodsInfo.sendGoodsDayMax+'天':'天'}}</div>
          </el-form-item>

          <el-form-item label="品质">
            <el-rate v-model="rate" :disabled="true" :colors="colors"></el-rate>
          </el-form-item>

          <el-form-item label="送货速度">
            <el-rate v-model="rate" :disabled="true" :colors="colors"></el-rate>
          </el-form-item>
        </el-form>
        <div class="add">
          <el-button class="item" disabled>直接购买</el-button>
          <el-button class="item" type="primary" disabled>加入购物车</el-button>
        </div>
      </div>

      <div class="same_goods">
        <same-goods :seriesLike="seriesLike"></same-goods>
      </div>
    </div>

    <!-- <recommended :list="list"></recommended> -->

    <div class="footer">
      <div class="like">
        <same-goods title="相似风格" :stylesLike="stylesLike"></same-goods>
      </div>
      <div class="itr_box">
        <goods-itr :goodsInfo="goodsInfo" :currentMix="currentMix" :classList="classList"></goods-itr>
      </div>
    </div>

    <back-top></back-top>
  </div>
</template>

<script>
import {
  GetGoodsMixBasicInfoForEdit,
  GetGoodsMixLikeInfo,
  GetGoodsMixPropInfoForEdit,
  GetGoodsMixServiceFeeNew,
} from "@/pages/page1/api/modules/goods";
import City from "@/pages/page1/components/city.vue";
import SameGoods from "./components/sameGoods.vue";
import Recommended from "./components/recommended.vue";
import GoodsItr from "./components/goodsItr.vue";
import BackTop from "@/pages/page1/components/backTop";
import onlyMessage from "@/pages/publicUtils/resetMessage.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  metaInfo: { title: "商品预览 - 多比商城" },
  components: {
    Swiper,
    SwiperSlide,
    City,
    SameGoods,
    Recommended,
    GoodsItr,
    BackTop,
  },
  data() {
    return {
      showLoading: true,
      swiperOption: {
        spaceBetween: 12, //间隔距离
        autoplay: false,
        // // loop:true,
        slidesPerView: 5,
      },
      activeIndex: 0,
      dataBreadcrumb: [], // 面包屑数据

      basicData: {}, // 获取到的商品总数据
      attrInfo: {
        attr1Info: {},
        attr2Info: {},
        attr3Info: {},
        attr4Info: {},
      },
      attrNumber: 0, //控制attr
      goodsInfo: {}, // 商品介绍
      goodsCount: 0, //商品数量
      rate: 5,
      colors: ["#D00000", "#D00000", "#D00000", "#D00000", "#D00000"],

      currentMix: {}, // 当前选中商品
      videoSrc: "", // 视频
      showVideo: false,
      effectImg: "", // 效果图展示
      effectBanner: [], // 效果图轮播
      localImgIndex: 0, //当前效果图图片索引

      isShowService: false, // 选中服务
      serviceFee: 0, //服务费
      freightFee: undefined, //运费
      regionCode: undefined,

      seriesLike: [], // 同系
      stylesLike: [], // 类似
      classList: [],
      queryMixSerNo: undefined, //url参数
    };
  },
  mounted() {
    this.queryMixSerNo = this.$route.query.mixSerNo;
    this.getGoodsDetailList(this.queryMixSerNo);
    // this.getGoodsLikeList(this.queryMixSerNo);//在售商品库才有，预览可能没有，关闭
    this.getGoodsMixPropInfoForEdit(this.queryMixSerNo);
  },
  methods: {
    // 不需要登录
    getGoodsDetailList(mixSerNo) {
      let params = {
        mixId: null,
        mixSerNo: mixSerNo,
      };
      this.showLoading = true;
      GetGoodsMixBasicInfoForEdit(params)
        .then((res) => {
          // console.log("获取某个商品信息", res);
          let data = res.data[0];
          // 保存原始数据
          this.basicData = data;
          // 初始化使用mixId相同的组合（就是商品编号的数据）
          let initialMix = data.mixs.find((v) => data.mixId == v.id);
          this.currentMix = initialMix;
          // 四个属性
          if (data.attrs.attr1Info) {
            this.actionAttr(data, "attr1Info");
            this.attrNumber += 1;
          }
          if (data.attrs.attr2Info) {
            this.actionAttr(data, "attr2Info");
            this.attrNumber += 1;
          }
          if (data.attrs.attr3Info) {
            this.actionAttr(data, "attr3Info");
            this.attrNumber += 1;
          }
          if (data.attrs.attr4Info) {
            this.actionAttr(data, "attr4Info");
            this.attrNumber += 1;
          }
          this.attrInfo.attr1Info.currentId = initialMix.attr1ContentId;
          this.attrInfo.attr2Info.currentId = initialMix.attr2ContentId;
          this.attrInfo.attr3Info.currentId = initialMix.attr3ContentId;
          this.attrInfo.attr4Info.currentId = initialMix.attr4ContentId;
          // 初始化展示数据
          this.writeData(this.currentMix, data);
          // 找到不存在的，不能点击
          this.findDisabled();
          this.showLoading = false;
        })
        .catch(() => (this.showLoading = false));
    },
    compare(propertyName, Desc) {
      //根据哪个属性值排序
      return function (obj1, obj2) {
        //对象两两比较 升序
        let value1 = obj1[propertyName];
        let value2 = obj2[propertyName];
        if (Desc) return value2 - value1;
        return value1 - value2;
      };
    },
    actionAttr(data, attr) {
      data.attrs[attr].contentList.sort(this.compare("sortOrder"));
      data.attrs[attr].contentList.forEach((v) => {
        this.$set(v, "isDisabled", false);
      });
      this.attrInfo[attr] = data.attrs[attr];
      this.$set(this.attrInfo[attr], "currentId", null);
    },
    writeData(resItem, data) {
      // 商品介绍
      this.goodsInfo = data.goodsInfo;
      this.goodsInfo.materialName = data.goodsInfo.materialNameList.join("+");
      this.goodsInfo.keyWords = data.goodsInfo.keyWordsArr.join(" ");
      this.goodsInfo.startPlace =
        data.goodsInfo.sendProvinceName + " " + data.goodsInfo.sendCityName;
      // 面包屑
      this.dataBreadcrumb.push({
        path: "/category",
        name: "全部产品",
        query: {},
      });
      this.dataBreadcrumb.push({
        path: "/category",
        name: data.goodsInfo.categoryName,
        query: { categorySerNo: data.goodsInfo.categorySerNo },
      });
      this.dataBreadcrumb.push({
        path: "/category",
        name: data.goodsInfo.brandName,
        query: { brandSerNos: data.goodsInfo.brandSerNo },
      });
      // 视频
      if (resItem.videoList.length > 0) {
        this.videoSrc = resItem.videoList[0].filePath;
      } else {
        this.videoSrc = "";
      }
      // 效果图轮播
      if (resItem.preImage.length == 0) {
        this.effectBanner = [];
        this.effectImg = require("@/assets/img/error-goods.jpg");
        return false;
      }
      this.effectBanner = resItem.preImage;
      // 主图排第一
      this.effectBanner.sort(this.compare("isMain", true));
      this.effectImg = this.effectBanner[0].filePath;
    },
    getGoodsLikeList(mixSerNo) {
      let params = {
        mixId: null,
        mixSerNo: mixSerNo,
        mixCount: 6,
      };
      GetGoodsMixLikeInfo(params).then((res) => {
        // console.log("获取相似商品", res);
        this.seriesLike = this.sliceArr(res.data[0].seriesLike);
        this.stylesLike = res.data[0].stylesLike;
      });
    },
    sliceArr(arr) {
      let result = [];
      for (var i = 0; i < arr.length; i += 3) {
        result.push(arr.slice(i, i + 3));
      }
      return result;
    },
    getGoodsMixPropInfoForEdit(mixSerNo) {
      let params = {
        mixId: null,
        mixSerNo: mixSerNo,
      };
      GetGoodsMixPropInfoForEdit(params).then((res) => {
        // console.log("获取规格参数", res);
        this.classList = res.data;
      });
    },
    getEndPlace(val) {
      // console.log(val);
      this.regionCode = val;
      this.getGoodsMixServiceFee();
    },
    //是否上门安装
    changeService() {
      if (!this.regionCode) {
        onlyMessage.warning("请选择收货地址");
        return;
      }
      this.isShowService = !this.isShowService;
      if (this.isShowService) this.getGoodsMixServiceFee();
    },
    onChangeCount() {
      if (!this.regionCode) return;
      this.getGoodsMixServiceFee();
    },
    getGoodsMixServiceFee() {
      let shoppingCartList = [];
      shoppingCartList.push({
        goodsMixId: this.currentMix.id,
        goodsCount: this.goodsCount,
      });
      GetGoodsMixServiceFeeNew({
        shoppingCartList,
        regionCode: this.regionCode,
      }).then((res) => {
        // console.log("获取服务费", res);
        this.serviceFee = res.data[0].serviceFee;
        this.freightFee = res.data[0].freightFee;
      });
    },
    // change四个属性
    changeAttr(item, attr) {
      attr.currentId = item.id;
      let resItem = this.basicData.mixs.find(
        (v) =>
          v.attr1ContentId == this.attrInfo.attr1Info.currentId &&
          v.attr2ContentId == this.attrInfo.attr2Info.currentId &&
          v.attr3ContentId == this.attrInfo.attr3Info.currentId &&
          v.attr4ContentId == this.attrInfo.attr4Info.currentId
      );
      if (!resItem) return;
      if (this.queryMixSerNo != resItem.serNo) {
        // 刷新
        let newUrl = this.$router.resolve({
          path: "/previewGoods",
          query: { mixSerNo: resItem.serNo },
        });
        window.open(newUrl.href, "_self");
      }
    },
    findDisabled() {
      switch (this.attrNumber) {
        case 1:
          this.forEachAttr1();
          break;
        case 2:
          this.forEachAttr1();
          this.forEachAttr2();
          break;
        case 3:
          this.forEachAttr1();
          this.forEachAttr2();
          this.forEachAttr3();
          break;
        case 4:
          this.forEachAttr1();
          this.forEachAttr2();
          this.forEachAttr3();
          this.forEachAttr4();
          break;
      }
    },
    forEachAttr1() {
      this.attrInfo.attr1Info.contentList.forEach((v) => {
        let result = this.basicData.mixs.find((item) => {
          return (
            item.attr1ContentId == v.id &&
            item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
            item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
            item.attr4ContentId == this.attrInfo.attr4Info.currentId
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    forEachAttr2() {
      this.attrInfo.attr2Info.contentList.forEach((v) => {
        let result = this.basicData.mixs.find((item) => {
          return (
            item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
            item.attr2ContentId == v.id &&
            item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
            item.attr4ContentId == this.attrInfo.attr4Info.currentId
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    forEachAttr3() {
      this.attrInfo.attr3Info.contentList.forEach((v) => {
        let result = this.basicData.mixs.find((item) => {
          return (
            item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
            item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
            item.attr3ContentId == v.id &&
            item.attr4ContentId == this.attrInfo.attr4Info.currentId
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    forEachAttr4() {
      this.attrInfo.attr4Info.contentList.forEach((v) => {
        let result = this.basicData.mixs.find((item) => {
          return (
            item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
            item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
            item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
            item.attr4ContentId == v.id
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    // 视频处理
    playVideo() {
      this.showVideo = true;
      this.$refs.video.play();
    },
    pauseVideo(index) {
      if (this.localImgIndex != index) {
        this.localImgIndex = index;
        this.effectImg = this.effectBanner[index].filePath;
      }
      this.showVideo = false;
      this.$refs.video.pause();
    },
    prevSlide() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    nextSlide() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    // 监听swiper的激活项变化
    onTransitionStart(val) {
      this.activeIndex = val.activeIndex;
    },
  },
};
</script>

<style lang="less" scoped>
.previewGoods {
  padding-top: 20px;
  padding-bottom: 100px;
  color: #333333;
  line-height: 1;
  .el-breadcrumb {
    font-size: 12px;
    .el-breadcrumb__item {
      a {
        color: #333333;
        font-weight: 400;
        &:hover {
          color: @themeColor;
        }
      }
    }
  }
  .header {
    display: flex;
    .media {
      width: 498px;
      height: 612px;
      box-sizing: border-box;
      .main_img {
        width: 100%;
        height: 498px;
        box-sizing: border-box;
        border: 1px solid #e4e4e4;
        position: relative;
        /deep/ .photo-zoom-pro {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .container {
            width: auto;
            height: auto;
            .origin-img {
              width: auto;
              height: auto;
              max-width: 496px;
              max-height: 496px;
            }
          }
        }
        video {
          width: 100%;
          height: 100%;
        }
        .play_icon {
          position: absolute;
          bottom: 10px;
          left: 10px;
          font-size: 60px;
          color: #404040;
          z-index: 3;
          cursor: pointer;
        }
      }
      .swiper_box {
        margin-top: 24px;
        width: 100%;
        height: 90px;
        position: relative;
        .swiper-container {
          height: 100%;
          img {
            border: 2px solid #ffffff;
            box-sizing: border-box;
          }
          .active {
            border: 2px solid @themeColor;
            box-sizing: border-box;
          }
        }
        .swiper-button-prev {
          left: 0;
        }
        .swiper-button-next {
          right: 0;
        }
        .swiper-button-next,
        .swiper-button-prev {
          top: 50%;
          margin-top: -11px;
          width: 22px;
          height: 22px;
          background-image: none;
          .myicon {
            font-size: 22px;
          }
        }
        .swiper-button-disabled {
          pointer-events: auto; //打开鼠标样式
          cursor: not-allowed;
        }
      }
    }
    .goods {
      // width: calc(100% - 498px - 176px);//516
      width: 516px;
      padding: 0 32px;
      box-sizing: border-box;
      font-size: 12px;
      .brand {
        display: flex;
        line-height: 30px;
        .style {
          background-color: @themeColor;
          padding: 0 15px;
          color: #ffffff;
        }
        .list {
          margin-left: 26px;
          color: #384e5b;
          a {
            color: #384e5b;
          }
        }
      }
      .name {
        margin-top: 4px;
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
      }
      .kw {
        margin-top: 10px;
        color: @themeColor;
      }
      .price {
        margin-top: 14px;
        width: 100%;
        height: 74px;
        box-sizing: border-box;
        padding-left: 20px;
        line-height: 74px;
        background: #f7f6f5;
        .text {
          padding-left: 38px;
          font-size: 16px;
          color: #d00000;
        }
        .money {
          font-size: 24px;
          font-weight: bold;
          color: #d00000;
        }
      }
      .com_el_form {
        margin-top: 28px;
      }
      .add {
        margin-top: 20px;
        .item {
          width: 132px;
          height: 36px;
          padding: 0;
          border-radius: 0;
          &:first-child {
            border-color: @themeColor;
            color: @themeColor;
          }
        }
        .el-button + .el-button {
          margin-left: 26px;
        }
      }
      .share {
        display: flex;
        align-items: center;
        margin-top: 20px;
        color: #696969;
        .myicon {
          font-size: 12px;
          color: #696969;
          margin-right: 6px;
          cursor: pointer;
          vertical-align: middle;
        }

        .activeI {
          color: #ff0000;
        }
      }
    }
    .same_goods {
      width: 176px;
      box-sizing: border-box;
    }
  }
  .footer {
    display: flex;
    margin-top: 100px;
    .like {
      width: 244px;
      margin-right: 46px;
    }
    .itr_box {
      width: calc(100% - 244px - 46px);
    }
  }
}
.mask {
  position: relative;
  &::after {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
}
/deep/ .el-loading-spinner {
  top: 300px;
}
</style>